import React from "react";
import BarChart from "./BarChart";
import { useQuery } from "react-query";
import { loanChart } from "services/LoanService";
import SectionLoader from "components/SectionLoader";

const ChartsComp = () => {
  const { data = { data: [] }, isLoading } = useQuery([], loanChart);

  if (isLoading || !data.data.length) {
    return <SectionLoader />;
  }

  const chartData = {
    labels: data.data.map(d => d.lga),
    datasets: [
      {
        label: "No. of Students",
        data: data.data.map(d => d.students || 0),
        backgroundColor: "rgba(137, 27, 124, 0.7)"
      }
    ]
  };

  return (
    <>
      <p className="text-lg mb-4">No. of Students by L.G.A</p>
      <div className="bg-white p-4 rounded-2xl min-h-[300px]">
        <BarChart barChartData={chartData} />
      </div>
    </>
  );
};

export default ChartsComp;
